import { render, staticRenderFns } from "./QuickSearchContactItem.vue?vue&type=template&id=13bf60e9&"
import script from "./QuickSearchContactItem.vue?vue&type=script&lang=js&"
export * from "./QuickSearchContactItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports